import { CancelResComponent } from './cancel-res/cancel-res.component';
import { ComponentsModule } from '../../components';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', component: CancelResComponent }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        ComponentsModule
    ],
    declarations: [
      CancelResComponent
    ],
    exports: [
        CancelResComponent
    ]
})
export class CancelResModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-res/cancel-res.module.ts